import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FloatingLabel,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
  Stack,
} from "react-bootstrap";
import { useAuth } from "../../../Context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "../../../utils/HttpClient";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";
import Loading from "../../ui/Suspense";
import RCSCardsLog from "./RCSCardsLog";
import dayjs from "dayjs";
import MissInfo from "../../MissInfo";

const _RCSLog = () => {
  const auth = useAuth();
  const { uid_partner, uid_user, token } = auth.getSessionData();
  const [searchMsisdn, setSearchMsisdn] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [sourceFilter, setSourceFilter] = useState(0);
  const [carrierFilter, setCarrierFilter] = useState(0);
  const [filterFrom, setFilterFrom] = useState(
    dayjs().subtract(1, "day").format("YYYY-MM-DD"),
  );
  const {
    data,
    refetch: getSmsData,
    isFetching: isLoading,
  } = useQuery({
    queryKey: ["getRCSData"],
    queryFn: async () => {
      const payload = {
        idpartner: uid_partner,
        limit: 50,
        user: uid_user,
        from: filterFrom,
        status: statusFilter || 0,
        msisdn: searchMsisdn || "",
        filter: sourceFilter || 0,
        carrier: carrierFilter || 0,
      };

      console.log(payload);

      const [reportRes, totalRes] = await Promise.all([
        httpClient(
          "POST",
          `${ApiEndpoint}reports/getRCSLogMessages`,
          payload,
          token,
        ),
        httpClient(
          "POST",
          `${ApiEndpoint}reports/getRCSLogMessagesHeader`,
          payload,
          token,
        ),
      ]);

      return {
        report: reportRes.data,
        total: totalRes.data?.total_results ?? 0,
      };
    },
    initialData: {
      report: [],
      total: 0,
    },
    refetchOnWindowFocus: false,
    suspense: true,
  });

  useEffect(() => {
    getSmsData();
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div>
      <div className="MessagesSended">
        <Stack direction="horizontal" gap={2}>
          <h6>Últimos mensajes recibidos</h6>
        </Stack>
        <Row>
          <Form.Group as={Col}>
            <FloatingLabel label="Fecha:" className="mb-1">
              <Form.Control
                type="date"
                name="dateFrom"
                id="dateFrom"
                value={filterFrom || new Date().toISOString()}
                placeholder="Del"
                onChange={(event) => {
                  setFilterFrom(event.target.value);
                }}
              />
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col}>
            <FloatingLabel label="Teléfono:" className="mb-3">
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-disabled">
                    Puede ingresar el telefono completo o parcial
                  </Tooltip>
                }
              >
                <Form.Control
                  type="text"
                  name="searchMsisdn"
                  id="searchMsisdn"
                  maxLength="10"
                  onkeypress="return event.charCode>=48 && event.charCode<=57"
                  value={searchMsisdn}
                  required
                  pattern="^\d{10}$"
                  onChange={(event) => {
                    event.target.value = event.target.value.replace(
                      /[^\d]+/g,
                      "",
                    );
                    setSearchMsisdn(event.target.value);
                  }}
                  placeholder="Ingrese el Telefono"
                />
              </OverlayTrigger>
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col}>
            <FloatingLabel label="Status *" className="mb-3">
              <Form.Select
                id="statusFilter"
                name="statusFilter"
                onChange={(selectedOption) => {
                  setStatusFilter(`${selectedOption.target.value}`);
                }}
                value={statusFilter}
                required
                aria-label="select_status"
              >
                <option value="0">Todos</option>
                <option value="1">En Proceso</option>
                <option value="2">Enviados</option>
                <option value="3">Error</option>
                <option value="4">No Validos</option>
              </Form.Select>
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col}>
            <FloatingLabel label="Origen *" className="mb-3">
              <Form.Select
                id="sourceFilter"
                name="sourceFilter"
                onChange={(selectedOption) => {
                  setSourceFilter(`${selectedOption.target.value}`);
                }}
                value={sourceFilter}
                required
                aria-label="select_source"
              >
                <option value="0">Todos</option>
                <option value="1">API</option>
                <option value="2">Campañas</option>
                <option value="3">Panel</option>
              </Form.Select>
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col}>
            <FloatingLabel label="Carrier *" className="mb-3">
              <Form.Select
                id="carrierFilter"
                name="carrierFilter"
                onChange={(selectedOption) => {
                  setCarrierFilter(`${selectedOption.target.value}`);
                }}
                value={carrierFilter}
                required
                aria-label="select_carrier"
              >
                <option value="0">Todos</option>
                <option value="1">Telcel</option>
                <option value="2">Movistar</option>
                <option value="3">AT&T</option>
                <option value="4">Otros</option>
              </Form.Select>
            </FloatingLabel>
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col}>
            <div className="text-right">
              <Button
                variant="primary"
                type="button"
                onClick={() => {
                  getSmsData();
                }}
              >
                Consultar
              </Button>
            </div>
          </Form.Group>
        </Row>
      </div>

      {data.report && data.report.length > 0 ? (
        <>
          <div className="text-xl font-bold text-gray-600 w-full my-3">
            Mostrando últimos {data.report.length} Registros de {data.total}
          </div>

          <RCSCardsLog data={data.report} />
        </>
      ) : (
        <MissInfo />
      )}
    </div>
  );
};

export default _RCSLog;
